import { Relations } from "@inrev/common";
import { useFetchAdminNoteTopics } from "@portal/api/note/admin";
import { ToolIcon } from "@portal/components/ui/ToolIcon";
import { CgMenuBoxed } from "react-icons/cg";

export const AdminNoteIcon = ({ relation, ...rest }: { relation: Relations.Notes }) => {
	const { defaultTopic, topics } = useFetchAdminNoteTopics(relation);

	const hasDefaultSummary = Boolean(
		defaultTopic &&
			defaultTopic.summary &&
			defaultTopic.summary !== "" &&
			defaultTopic.summary !== "<p></p>",
	);
	const openDefaultNotes = defaultTopic?.notes.filter((note) => !note.isArchived) ?? [];
	const openTopics = topics?.filter((topic) => !topic.isArchived) ?? [];
	const openTopicNotes = openTopics.flatMap((topic) =>
		topic.notes.filter((note) => !note.isArchived),
	);

	// Open Notes is a combination of:
	// - If the default topic has a summary, count is as 1 open note
	// - The number of open notes in the default topic
	// - The number of open topics with summaries (each topic with a summary counts as 1 open note)
	// - The number of open notes in all open topics
	const numOpenNotes =
		(hasDefaultSummary ? 1 : 0) +
		openDefaultNotes.length +
		openTopics.length +
		openTopicNotes.length;

	return (
		<ToolIcon
			icon={<CgMenuBoxed />}
			label="Notes"
			notifications={{ count: numOpenNotes, color: "gray" }}
			{...rest}
		/>
	);
};
